<!-- SPLASH -->
@if (appS.splash) {
  <manager-splash [@fadeInOnEnter] [@fadeOutOnLeave]></manager-splash>
}

<!-- CONTENT -->
<div id="manager-content" [class]="{ 'd-none': appS.splash }" class="h-100 w-100">
  <router-outlet></router-outlet>
</div>
